import { createForm } from '@seek/forms-ui';
import {
  Stack,
  ContentBlock,
  Heading,
  Text,
  TextField,
  Inline,
  Button,
  Actions,
  Columns,
  Column,
  Card,
  Box,
} from 'braid-design-system';
import React, { type FormEvent } from 'react';

import Routes from 'src/config/routes';

import alphabetLinks from './components/AlphabetLinks/AlphabetLinks';

const FORM_NAME = 'brandSearchForm';

interface FormValues {
  keyword: string;
}

const { FormProvider, useField } = createForm<FormValues>(FORM_NAME);

const submit = (formData: { keyword: string }) => {
  window?.location.assign(
    `${Routes.FRANCHISE_DIRECTORY}search?kw=${
      formData.keyword === '' ? 'all' : formData.keyword
    }`,
  );
};

interface Props {
  handleSubmit: (
    submit: (formData: FormValues) => void,
  ) => (event: FormEvent) => void;
}

const BrandSearchForm = ({ handleSubmit }: Props) => {
  const keyword = useField({
    id: 'keyword',
  });

  return (
    <Card>
      <ContentBlock>
        <Stack space="large">
          <Heading level="2">Find a franchise brand</Heading>
          <form onSubmit={handleSubmit(submit)}>
            <Box style={{ maxWidth: 470 }}>
              <Columns space="small">
                <Column>
                  <TextField
                    id="keyword"
                    aria-label="keywordSearch"
                    value={keyword.value}
                    onChange={keyword.onChange}
                    placeholder="Search by name"
                    data={{ testid: 'keyword' }}
                  />
                </Column>
                <Column width="content">
                  <Actions>
                    <Button type="submit" data={{ testid: 'findButton' }}>
                      Find
                    </Button>
                  </Actions>
                </Column>
              </Columns>
            </Box>
          </form>
          <Text>
            <Inline space={['xsmall', 'xsmall', 'medium']}>
              {alphabetLinks()}
            </Inline>
          </Text>
        </Stack>
      </ContentBlock>
    </Card>
  );
};

const BrandSearch = () => (
  <FormProvider initialValues={{ keyword: '' }}>
    {({ handleSubmit }) => <BrandSearchForm handleSubmit={handleSubmit} />}
  </FormProvider>
);

export default BrandSearch;
